import React from 'react'
import { Button, ConfigProvider, Drawer, Typography } from 'antd'
import { ColumnsType } from 'antd/es/table'
import styles from './MobileFiltersDrawer.module.scss'

export interface IMobileFilterSection {
  title: string
  content: React.ReactNode
}

interface IMobileFiltersDrawerProps {
  open: boolean
  onClose: () => void
  title?: string
  // колонки десктопной таблицы: их filterDropdown отрисовываем в шторке,
  // чтобы фильтры не пришлось описывать второй раз
  columns: ColumnsType<any>
  sections?: IMobileFilterSection[]
  // применение и сброс знает только список: у него запрос и состояние фильтров
  onApply?: () => void
  onReset?: () => void
}

// фильтры колонок закрывают дропдаун после выбора — в шторке это закрыло бы её целиком
const keepOpen = () => undefined

export const MobileFiltersDrawer: React.FC<IMobileFiltersDrawerProps> = ({
  open,
  onClose,
  title = 'Фильтры',
  columns,
  sections = [],
  onApply,
  onReset
}) => {
  const filterColumns = columns.filter(
    (column) => typeof (column as any).filterDropdown === 'function'
  )

  const handleApply = () => {
    onApply?.()
    onClose()
  }

  const handleReset = () => {
    onReset?.()
    onClose()
  }

  return (
    <Drawer
      open={open}
      onClose={onClose}
      placement='bottom'
      height='auto'
      title={title}
      footer={
        <div className={styles.footer}>
          <Button size='large' onClick={handleReset}>
            Очистить
          </Button>
          <Button size='large' type='primary' onClick={handleApply}>
            Применить
          </Button>
        </div>
      }
      rootClassName={styles.drawer}
    >
      <ConfigProvider componentSize='large'>
        {sections.map((section) => (
          <div key={section.title} className={styles.section}>
            <Typography.Text strong>{section.title}</Typography.Text>
            {section.content}
          </div>
        ))}
        {filterColumns.map((column, index) => {
          const { title: columnTitle, filterDropdown } = column as any
          return (
            <div key={String(column.key ?? (column as any).dataIndex ?? index)} className={styles.section}>
              <Typography.Text strong>
                {typeof columnTitle === 'function' ? null : (columnTitle as React.ReactNode)}
              </Typography.Text>
              {filterDropdown({ close: keepOpen })}
            </div>
          )
        })}
      </ConfigProvider>
    </Drawer>
  )
}
